import React, {
	useEffect, useState, useRef,
} from 'react';
import { useSelector } from 'react-redux';
import Clock from '../../general-components/clock';
import { ROOM_STATES } from '../../../stores/reducers/settings';
import { BROADCAST_STATES } from '../../../stores/types/broadcasting';
import { GreenroomState as GS } from '../../../stores/types/types';
import { isThirtySecondsToStart } from '../../../utils/scheduled-streaming';
import { RoomStates } from '../../../types/enums';

interface Props {
	host: boolean;
	scheduledStartTime?: Date;
	meetingSlug?: string;
	meetingStartTime?: Date;
	roomState: RoomStates;
	serverState: number;
}

export default function HeaderClockContainer(props: Props) {
	const {
		host,
		scheduledStartTime,
		meetingSlug,
		meetingStartTime,
		roomState,
		serverState,
	} = props;
	
	const backstageCommsActive = useSelector((s: GS) => s.SettingsReducer.backstageCommsActive);

	const [scheduledStreamCommModalOpen, setScheduledStreamCommModalOpen] = useState<boolean>(false);
	const ignoredCommsModal = useRef<boolean>(false);

	let clockInterval: NodeJS.Timeout;

	const shouldSetJoinAndCheckCommsModal = useRef<boolean>(false);

	const updateClock = (startTime: Date, meetingId: string) => {
		clockInterval = setInterval(() => {
			// if we're a producer, we have a scheduled stream, comms are off, and we are not in the modal
			if (shouldSetJoinAndCheckCommsModal.current && meetingId) {
				const isLive = roomState === ROOM_STATES.SHOWTIME
					&& serverState === BROADCAST_STATES.BROADCAST_STARTED;

				const timeJoinRoom = JSON.parse(localStorage.getItem('time-join-rooms') || '{}');
				const now = Date.now();

				if (
					!timeJoinRoom?.[meetingId] // if we have never been in this room before
					// if last in room was more than 24 hours ago, reset
					|| (timeJoinRoom?.[meetingId]?.joinTime + (24 * 60 * 60 * 1000) < now)
				) {
					timeJoinRoom[meetingId] = {
						joinTime: now,
					};
					localStorage.setItem('time-join-rooms', JSON.stringify(timeJoinRoom));
				} else if (!isLive && timeJoinRoom?.[meetingId]) { // clear it if we are not live
					delete timeJoinRoom[meetingId];
					localStorage.setItem('time-join-rooms', JSON.stringify(timeJoinRoom));
				}

				if (
					(isLive && timeJoinRoom?.[meetingId]?.joinTime + (5 * 60 * 1000) > now)
					|| (!isLive && isThirtySecondsToStart(startTime))
				) {
					if (!scheduledStreamCommModalOpen && !ignoredCommsModal.current) {
						setScheduledStreamCommModalOpen(true);
					}
				}
			}
		}, 5 * 1000);
	};

	useEffect(() => {
		clearInterval(clockInterval);
		shouldSetJoinAndCheckCommsModal.current = false;
		if (meetingSlug && scheduledStartTime && host && !backstageCommsActive) {
			shouldSetJoinAndCheckCommsModal.current = true;
			updateClock(scheduledStartTime, meetingSlug);
		}

		return () => {
			clearInterval(clockInterval);
		};
	}, [meetingSlug, scheduledStartTime, host, backstageCommsActive]);

	return (<>
		<div className="margin-right-small stylepacks-do-fade">
			<Clock startTime={meetingStartTime}/>
		</div>
	</>);
}
